import { WaterPlusIcon } from './WaterPlusIcon';

/**
 * author: Colton Wiscombe
 * id B7B4ACBA-F24A-48D7-A409-965A32860CE9
 * name water-plus
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-plus.svg
 * tags
 */
export const DropPlusIcon = WaterPlusIcon;
export default DropPlusIcon